<template>
  <CartButtonMobile
    v-if="isMobile"
    :is-trashbin-button="cartContentStore.cartButtonType === CartButtonEnum.trashbin"
    :is-in-cart="isInCart"
    :cart-content-link="`/${commonAnalysesStore.town.translit}/analyses/cart/content/`"
    :disable-cart-button="disableCartButton"
    @click:add="handleAddAnalysisToCart"
    @click:delete="handleDeleteAnalysisFromCart"
  />
  <CartButtonDesktop
    v-else
    :is-trashbin-button="cartContentStore.cartButtonType === CartButtonEnum.trashbin"
    :is-in-cart="isInCart"
    :cart-content-link="`/${commonAnalysesStore.town.translit}/analyses/cart/content/`"
    :disable-cart-button="disableCartButton"
    @click:add="handleAddAnalysisToCart"
    @click:delete="handleDeleteAnalysisFromCart"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import YandexGoals from 'www/modules/YandexGoals'
import dispatchCustomEventGlobally from 'www/utils/withDependences/dispatchCustomEventGlobally'
import useCartContentStore from 'www/vue_components/common/Analyses/stores/useCartContentStore'
import { CartButtonEnum } from 'www/vue_components/common/Analyses/enums'
import useCommonAnalysesStore from 'www/vue_components/common/Analyses/stores/useCommonStore'
import { Partner } from 'www/vue_components/common/Analyses/types'
import CartButtonMobile from 'www/vue_components/common/Analyses/components/AnalysisCard/components/CartButtonMobile.vue'
import CartButtonDesktop from 'www/vue_components/common/Analyses/components/AnalysisCard/components/CartButtonDesktop.vue'

const emit = defineEmits(['click:add-to-cart', 'click:delete-from-cart'])

defineProps<{
  isInCart: boolean
  analysisId: number
  analysisSynonymId: number
  biomaterialId: number
  partner: Partner
  disableCartButton: boolean
}>()

const cartContentStore = useCartContentStore()
const commonAnalysesStore = useCommonAnalysesStore()
const { isCategoryPage } = storeToRefs(commonAnalysesStore)

const YaGoals = new YandexGoals()
const isMobile = window.MOBILE_VERSION

const { isDoctor } = window.USER

function handleDeleteAnalysisFromCart() {
  if (isDoctor) {
    emit('click:delete-from-cart')
    return
  }

  dispatchCustomEventGlobally('dialog:open', {
    maxWidth: 304,
    noClickAnimation: true,
    title: 'Удалить анализ из корзины?',
    confirmText: 'Удалить',
    closeText: 'Отменить',
    attachSelector: '#use-vue-base-dialog',
    isDanger: true,
    beforeConfirm: async () => {
      emit('click:delete-from-cart')
    },
  })
}

async function handleAddAnalysisToCart() {
  if (isCategoryPage.value) {
    YaGoals.send({ name: 'analyses-category-added-category-analysis' })
  }

  if (!isCategoryPage.value) {
    YaGoals.send({ name: 'analyses-category-added-analysis' })
  }

  emit('click:add-to-cart')
}
</script>
